import React, { useState, useEffect,useRef } from "react";
import styles from "./QuestionPage.module.css";
import logo from "./images/unisologo.png"; // put your logo in this path
import {
  isTokenExpired,
  removeToken,
  getToken,
  decodeToken,
} from "../../utils/TokenUtils";
import { API_URL, ENDPOINTS, postData } from "../../constants/api";
import axios from "axios";
import { useLocation } from "react-router-dom";

import { useNavigate } from "react-router-dom";
import KtcHeader from "./Ktcheader";
import KtcMyFooter from "./ktc_my_footer";


const KtcQuestionPage = () => {
  const [scheduleDate, setScheduleDate] = useState({});
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [currentIndex, setCurrentIndex] = useState(0);
  const [timeLeft, setTimeLeft] = useState(60 * 60); // 1 hour timer
  const [submitted, setSubmitted] = useState(false);

   const [cameraOn, setCameraOn] = useState(false);
  const [stream, setStream] = useState(null);
  const videoRef = useRef();

  const location = useLocation();
  const { state } = location;
  const { student_id, class_id, course_id, exam_type,id,student_type } = state || {};
  console.log('std:',student_id,'class',class_id,'course',course_id,'exam',exam_type,'std type',student_type)
  const navigate = useNavigate();

  // ===== Fetch Exam Info and Questions =====
  useEffect(() => {
    const getData = async () => {
      try {
        const url = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/web-get-schedule`;
        const body = { id: id };
        const response = await postData(url, body);
        const courseData = response.data[0];
        console.log("schedule date from response:", courseData);
        setScheduleDate(courseData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

   const getQuestion = async () => {
  try {
    let url;

    if (student_type === "class") {
      url = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/web-question`;
    } else {
      url = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/web-question-by-student`;
    }

    const body =
      student_type === "class"
        ? {
            class_id: class_id,
           course_id: course_id,
            exam_type: exam_type,
          }
        : {
            student_id: student_id,
            course_id: course_id,
          };

    // ✅ REQUIRED CONSOLE LOGS
    console.log("📡 REQUEST URL:", url);
    console.log("📦 REQUEST BODY:", body);
    console.log("👤 STUDENT TYPE:", student_type);

    const response = await postData(url, body);

    console.log("✅ QUESTIONS RESPONSE:", response.data);

    setQuestions(Array.isArray(response.data) ? response.data : []);
  } catch (error) {
    console.error("❌ Error fetching questions:", error);
  }
};


    if (!id || !student_type) return;

  getData();
  getQuestion();


  }, [id, student_type, student_id, course_id,  exam_type]);

  // ===== Timer Countdown =====
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          handleSubmit(); // Auto-submit when time is up
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const openCamera = async () => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({
      video: true,
      audio: false,
    });

    setCameraOn(true);       // camera accepted
    setStream(stream);       // optional: for video
  } catch (err) {
    console.error("Camera error:", err);
    setCameraOn(false);
  }
};

useEffect(() => {
  openCamera();
}, []);


  const formatTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hrs}h ${mins}m ${secs}s`;
  };

const normalizeAnswer = (str) => {
  if (!str) return "";
  
  const lower = str.toLowerCase();

  // If it contains ":", split and take the right side
  if (lower.includes(":")) {
    return lower.split(":")[1].trim();
  }

  // If no colon, return whole string trimmed
  return lower.trim();
};


  // ===== Handle Answer Selection =====
const handleAnswer = (index, value, question_id) => {
  setAnswers((prev) => {

    const question = questions.find((q) => q["id~hide"] === question_id);
    console.log('question',question)
    let marks = 0;

    if (question.type === "tf" || question.type === "choose") {
      const cleaned = question.correct_answer.replace(/\./g, "");

  const a = normalizeAnswer(value);
  const b = normalizeAnswer(cleaned);

  console.log("compare:", { a, b });

  if (a === b) {
    marks = question.marks || 1;
  } else {
    marks = 0;
  }
}



    return {
      ...prev,
      [question_id]: {
        answer: value,
        marks: marks,
        question_id: question_id,
        type: question?.type || null,
      },
    };
  });
};


// ===== Submit Answers =====
const handleSubmit = async () => {
  try {
    const token = getToken();
    const insertUrl = `${API_URL}/${ENDPOINTS.SYS}/create/web_answer`;
    const currentDate = new Date().toISOString().split("T")[0];

    const answerRows = Object.values(answers).map((ans) => ({
      student_id: student_id,
      question_id: ans.question_id,
      marks: ans.marks,
      answer: ans.answer,
      user_id: student_id,
      date: currentDate,
    }));

    console.log("📤 Submitting answers (row-by-row):", answerRows);

    for (const row of answerRows) {
      const response = await axios.post(insertUrl, row, {
        headers: {
          Authorization: token ? `Bearer ${token}` : "",
        },
      });
      console.log("message:", response.data);
    }
    setCameraOn(false);
    setSubmitted(true);
   

    // Navigate after 3 seconds
   setTimeout(() => {
  navigate("/student-portal");      // navigate
  window.location.reload();          // reload page
}, 1000);

  } catch (error) {
    console.error("❌ Submission error:", error);
    alert("Failed to submit answers. Please try again.");
  }
};

// ===== Submitted Message =====
if (submitted) {
  return (
    <>
     <KtcHeader></KtcHeader>
      <div className={styles.container}>
        <h2>Thank you! Your answers have been submitted.</h2>
        
      </div>
        <KtcMyFooter></KtcMyFooter>
    </>
  );
}

  

  // ===== Current Question Rendering =====
  const currentQuestion = questions[currentIndex];

  return (
    <>
     <KtcHeader></KtcHeader>
      <div className={styles.container}>
        {/* ===== Exam Header ===== */}
        <header className={styles.header}>
          <div className={styles.headerTop}>
            <img src={logo} alt="University Logo" className={styles.logo} />
            <h1 className={styles.university}>University of Somalia - UNISO</h1>
          </div>

          <div className={styles.headerInfo}>
            <p>
              <strong>Course:</strong> {scheduleDate?.["course"]} &nbsp;|&nbsp;
             
            </p>
            <p>
              <strong>Duration:</strong>{" "}
              {scheduleDate?.start_exam?.split(" ")[1]} -{" "}
              {scheduleDate?.end_Exam?.split(" ")[1]}
            </p>
            <p>
           
            </p>
            <p>
              <strong>
                Question {currentIndex + 1} of {questions.length}
              </strong>
            </p>
          </div>
        </header>

        {/* ===== One Question Display ===== */}
       {
  cameraOn ? (
    <>
      <div className={styles.questions}>
        {currentQuestion && (
          <div className={styles.questionCard}>
            <h3 className={styles.qText}>
              {currentIndex + 1}. {currentQuestion.name}
              <span className={styles.marks}>
                ({currentQuestion.marks} marks)
              </span>
            </h3>

            {/* True / False */}
            {currentQuestion.type === "tf" && (
              <div className={styles.optionGroup}>
                {["True", "False"].map((opt) => (
                  <label
                    key={`${currentQuestion["id~hide"]}_${opt}`}
                    className={`${styles.option} ${
                      answers[currentQuestion["id~hide"]]?.answer === opt
                        ? styles.selected
                        : ""
                    }`}
                  >
                    <input
                      type="radio"
                      name={`q_${currentQuestion["id~hide"]}`}
                      onChange={() =>
                        handleAnswer(
                          currentIndex,
                          opt,
                          currentQuestion["id~hide"]
                        )
                      }
                    />
                    {opt}
                  </label>
                ))}
              </div>
            )}

            {/* Multiple Choice */}
            {currentQuestion.type === "choose" && (
              <div className={styles.optionGroup}>
                {currentQuestion.options.split(",").map((opt, i) =>
                  opt.length > 3 ? (
                    <label
                      key={`${currentQuestion["id~hide"]}_${i}`}
                      className={`${styles.option} ${
                        answers[currentQuestion["id~hide"]]?.answer === opt
                          ? styles.selected
                          : ""
                      }`}
                    >
                      <input
                        type="radio"
                        name={`q_${currentQuestion["id~hide"]}`}
                        onChange={() =>
                          handleAnswer(
                            currentIndex,
                            opt,
                            currentQuestion["id~hide"]
                          )
                        }
                      />
                      {opt}
                    </label>
                  ) : null
                )}
              </div>
            )}

            {/* Direct Answer */}
            {currentQuestion.type === "direct" && (
              <textarea
                className={styles.directInput}
                placeholder="Write your answer here..."
                value={answers[currentQuestion["id~hide"]]?.answer || ""}
                onChange={(e) =>
                  handleAnswer(
                    currentIndex,
                    e.target.value,
                    currentQuestion["id~hide"]
                  )
                }
              ></textarea>
            )}
          </div>
        )}
      </div>

      {/* Navigation Buttons */}
      <div
        className={styles.navButtons}
        style={{ marginTop: "20px", padding: "15px" }}
      >
        {currentIndex < questions.length - 1 ? (
          <button
            onClick={() => setCurrentIndex((prev) => prev + 1)}
            className={styles.nextBtn}
          >
            Next
          </button>
        ) : (
          <button onClick={handleSubmit} className={styles.submitBtn}>
            Submit
          </button>
        )}
      </div>
    </>
  ) : null
}

      </div>
      <KtcMyFooter></KtcMyFooter>
    </>
  );
};

export default KtcQuestionPage;
